var map = {
	"./20coperti/thumbnail.jpg": "3233",
	"./20dicembre/thumbnail.jpg": "8b58",
	"./eulost/thumbnail.jpg": "01a5",
	"./fungisamurai/thumbnail.jpg": "b4cf",
	"./hrfestival/thumbnail.jpg": "e1ee",
	"./mopay/thumbnail.jpg": "fed2",
	"./nespresso/thumbnail.jpg": "3f8d",
	"./portrait/thumbnail.jpg": "b612",
	"./sketch/thumbnail.jpg": "c843",
	"./square/thumbnail.jpg": "92c2",
	"./tlc/thumbnail.jpg": "90ed",
	"./urdrugs/thumbnail.jpg": "15a2",
	"./whatever/thumbnail.jpg": "ee8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "803f";